































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import FieldListItem from '@/app/components/Field/FieldListItem.vue'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'

@Component({
  components: {
    Loading,
    FieldListItem
  }
})
export default class FieldList extends Vue {
  private fieldId: string = ''
  private displayFieldData: Array<{[key:string]: string}> = []
  private detailsData: any[] = []
  private showLoading: boolean = true

  @Prop() private fieldList!: Array<{[key:string]: string}>
  @Prop() private id!: number
  @Prop() private flag!: boolean
  @Prop() private displayFlag!: boolean
  @Prop() private accordionChangeFlag!: boolean

  /* computed */
  private get fieldDataState (): number {
    return this.$store.state.fieldState.fieldData
  }
  private get props (): any {
    return this.fieldList
  }

  @Watch('fieldDataState')
  private onDataChange (newValue: any) {
    this.displayFieldData = []
    this.changeData(newValue)
  }
  @Watch('props')
  private propsData (newValue: any) {
    let id:number = this.id
    let dataList: any[] = []

    // アコーディオンIDが同じもののみ抽出
    for (var i in this.fieldList) {
      if (parseInt(this.fieldList[i].accordionId) === id) {
        dataList.push(this.fieldList[i])
      }
    }

    this.displayFieldData = dataList
  }

  created () {
    let id:number = this.id
    let dataList: any[] = []

    // アコーディオンIDが同じもののみ抽出
    for (var i in this.fieldList) {
      if (parseInt(this.fieldList[i].accordionId) === id) {
        dataList.push(this.fieldList[i])
      }
    }

    this.displayFieldData = dataList
  }

  mounted () {
    let choiceId = this.$route.hash.slice(1)

    if (Session.getChoiceFieldId()! !== null && this.flag) {
      /* ひとつ前に選択していた圃場を開く */
      let fieldId = Session.getChoiceFieldId()
      this.$store.commit('fieldChoiceState/setChoosingFieldId', fieldId)
      let el: any = document.getElementById(String(fieldId))
      if (el !== null) {
        let accordionId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
        let index = accordionId.indexOf('/')
        let id = accordionId.slice(index + 1)
        this.$emit('openSpecificAccordion', id)
      }
    }

    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (this.$route.name === '圃場詳細' && settingData !== null) {
      if (settingData.tab === '3') {
        let el: any = document.getElementById(String(settingData.fieldId))
        if (el !== null) {
          let accordionId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
          let index = accordionId.indexOf('/')
          let id = accordionId.slice(index + 1)
          this.$emit('openSpecificAccordion', id)
        }
      }
    }
  }

  private changeData (val: any) {
    let id:number = this.id
    this.displayFieldData = val.filter(function (data: any) {
      return (data.area_id === id)
    })
  }

  public toggleLoading () {
    this.showLoading = false
  }
}
